import type { SearchFailedPayloadInput, SearchSessionEndedPayloadInput } from './search-diagnostics'
import { truncateForJsonByteBudget as truncatePendoString } from './payload-size'

const MAX_SESSION_QUERY_LENGTH = 40
const MAX_FAILED_QUERY_LENGTH = 120
const MAX_REASON_LENGTH = 30
const MAX_SORT_ORDER_LENGTH = 40

export function buildSearchSessionEndedPayload(input: SearchSessionEndedPayloadInput) {
  const hasResults = input.resultCountOnPage > 0 || input.totalResults > 0
  const hadMeaningfulEngagement =
    input.clickedResult ||
    input.reformulated ||
    input.continuedSearch ||
    input.usedPagination ||
    input.changedFilters ||
    input.changedSort
  const endedWithoutEngagement = !hadMeaningfulEngagement && input.endReason === 'left_search_page'

  return {
    searchId: input.searchId,
    query: truncatePendoString(input.query, MAX_SESSION_QUERY_LENGTH, MAX_SESSION_QUERY_LENGTH),
    queryLength: input.query.trim().length,
    page: input.page,
    totalResults: input.totalResults,
    resultCountOnPage: input.resultCountOnPage,
    hasResults,
    clickedResult: input.clickedResult,
    resultClickCount: input.resultClickCount,
    firstClickedRank: input.firstClickedRank,
    reformulated: input.reformulated,
    continuedSearch: input.continuedSearch,
    usedPagination: input.usedPagination,
    changedFilters: input.changedFilters,
    changedSort: input.changedSort,
    timeOnSerpMs: Math.max(0, input.timeOnSerpMs),
    endReason: truncatePendoString(input.endReason, MAX_REASON_LENGTH, MAX_REASON_LENGTH),
    wasAbandoned: hasResults && endedWithoutEngagement,
    wasBounce: endedWithoutEngagement,
  }
}

export function buildSearchFailedPayload(input: SearchFailedPayloadInput) {
  return {
    query: truncatePendoString(input.query, MAX_FAILED_QUERY_LENGTH, MAX_FAILED_QUERY_LENGTH),
    queryLength: input.query.trim().length,
    queryTokenCount: input.query.trim().split(/\s+/).filter(Boolean).length,
    page: input.page,
    statusCode: input.statusCode,
    errorType: truncatePendoString(input.errorType, MAX_REASON_LENGTH, MAX_REASON_LENGTH),
    hasFilters: input.hasFilters,
    filterCount: input.filterCount,
    sortOrder: truncatePendoString(input.sortOrder, MAX_SORT_ORDER_LENGTH, MAX_SORT_ORDER_LENGTH),
  }
}
